import React, { memo, useEffect, useRef, useState } from "react";
import styles from "./CheckoutForm.module.scss";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import Modal from "../Modal/Modal";
import { LeftArrowIcon } from "../../../../assets/icons/svgicons";
import Button from "../../Button/Button";
import { Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  createIntentAction,
  stripeWebhookAction,
} from "../../../../features/marketPlace/marketPlaceSlice";
import {
  startLoading,
  stopLoading,
} from "../../../../features/loading/loadingSlice";
import { WEB_URL } from "../../../../utils/constants";

const StripeCheckoutForm = ({ show, handleClose, data, resetForm }) => {
  const dispatch = useDispatch();
  const rowRef = useRef();

  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState(null);

  const getElementError = () => { };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (elements == null) return;
    const { error: submitError } = await elements.submit();
    if (submitError) {
      // Show error to your customer
      setErrorMessage(submitError.message);
      return;
    }

    const res = await dispatch(createIntentAction(data));
    // return;
    const clientSecret = res.data.data.client_secret;
    dispatch(startLoading());
    const { error } = await stripe.confirmPayment({
      elements,
      clientSecret,
      confirmParams: {
        return_url: `${WEB_URL}/auth/payment-status`,
      },
    });
    if (error) {
      dispatch(stopLoading());
      setErrorMessage(error.message);
    } else {
      resetForm()
      dispatch(stopLoading());
      alert("Payment Successfully done!");
    }
  };

  return (
    <Modal
      show={show}
      handleClose={handleClose}
      title={
        <span onClick={handleClose}>
          <LeftArrowIcon />
          Back
        </span>
      }
      hideCloseBtn
      className={styles.edit_profile}
    >
      <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
        <Row ref={rowRef}>
          <PaymentElement />
        </Row>
        <Button
          type="button"
          disabled={!stripe || !elements}
          fluid
          className={styles.submit_btn}
          onClick={(e) => {
            handleSubmit(e);
          }}
        >
          Pay
        </Button>
      </form>
    </Modal>
  );
};

export default memo(StripeCheckoutForm);
